import React, { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import {
  Checkbox,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';

import { ClientInvitationFragment } from 'api';
import { TableCellWithOverflow } from 'components';
import { generateLink } from 'Links';
import { getFullName } from 'helpers';

import Loader from './Loader';

interface IProps {
  sentinelRef: (node: Element) => void;
  results: ClientInvitationFragment[];
  checkedIds: string[];
  isAllChecked: boolean;
  isExhausted: boolean;
  isInitialLoad: boolean;
  onAllChecked: (event: ChangeEvent<HTMLInputElement>) => void;
  onChecked: (event: ChangeEvent<HTMLInputElement>) => void;
}

const AdminPendingInvitationsTable: FC<IProps> = ({
  sentinelRef,
  results,
  checkedIds,
  isAllChecked,
  isExhausted,
  isInitialLoad,
  onAllChecked,
  onChecked,
}) => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox checked={isAllChecked} onChange={onAllChecked} />
          </TableCell>
          <TableCell>{t('common:to')}</TableCell>
          <TableCell>{t('admin:invitedBy')}</TableCell>
          <TableCell>{t('admin:lastSent')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {isInitialLoad && <Loader sentinelRef={null} rows={8} />}
        {results.map(result => (
          <TableRow key={result.id}>
            <TableCell padding="checkbox">
              <Checkbox
                name={result.id}
                checked={checkedIds.includes(result.id)}
                onChange={onChecked}
              />
            </TableCell>
            <TableCell>
              <Typography title={result.email_address}>{result.email_address}</Typography>
            </TableCell>
            <TableCellWithOverflow>
              <Link
                title={getFullName(result.added_by_user)}
                component={generateLink(`/profile/${result?.added_by_user?.id}`)}
                variant="body1"
              >
                {getFullName(result.added_by_user)}
              </Link>
            </TableCellWithOverflow>
            <TableCell>
              <Typography title={moment.unix(result.created_at).format('l')}>
                {moment.unix(result.created_at).format('l')}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
        {!isExhausted && <Loader sentinelRef={sentinelRef} rows={1} />}
      </TableBody>
    </Table>
  );
};

AdminPendingInvitationsTable.defaultProps = {
  results: [],
};

export default AdminPendingInvitationsTable;
